import React from 'react';
import { TrendingUp, TrendingDown, Info } from 'lucide-react';


          {/* <div className="bg-white p-6 rounded-xl shadow-xl border-t-4 border-purple-500"> */}

// export const MetricCard2 = ({ title, value, icon, trend, color, tooltip }) => (
//   <div className="bg-white p-5 rounded-xl shadow-lg border-l-4 border-cyan- border-purple-500">
//     <div className="flex items-center justify-between">
//       <div className="flex items-center">
//         <p className="text-sm font-medium text-gray-500">{title}</p>
//         {tooltip && (
//           <span className="relative group inline-flex items-center ml-2">
//             <Info
//               className="w-4 h-4 text-gray-400 group-hover:text-gray-600 cursor-help"
//               tabIndex={0}
//               aria-label="More info"
//               title={typeof tooltip === 'string' ? tooltip : undefined}
//             />
//             <div
//               role="tooltip"
//               className="absolute left-0 top-full mt-2 w-64 bg-gray-900 text-white text-xs rounded-md p-2 shadow-xl opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity z-20"
//             >
//               {tooltip}
//             </div>
//           </span>
//         )}
//       </div>
//       {icon && React.cloneElement(icon, { className: `w-6 h-6 ${color}` })}
//     </div>
//     <div className="mt-1 flex items-end">
//       <p className="text-3xl font-bold text-gray-900">{value}</p>
//       {trend && (
//         <div className={`ml-3 text-sm font-semibold flex items-center ${trend.includes('Up') ? 'text-green-600' : 'text-red-600'}`}>
//           {trend.includes('Up') ? <TrendingUp className="w-4 h-4 mr-1" /> : <TrendingDown className="w-4 h-4 mr-1" />}
//           {trend}
//         </div>
//       )}
//     </div>
//   </div>
// );


const MetricCard = ({ title, value, icon, trend, color, tooltip, children }) => (
  <div className="bg-white p-5 rounded-xl shadow-lg border-l-4 border-cyan-500">
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <p className="text-sm font-medium text-gray-500">{title}</p>
        {tooltip && (
          <span className="relative group inline-flex items-center ml-2">
            <Info
              className="w-4 h-4 text-gray-400 group-hover:text-gray-600 cursor-help"
              tabIndex={0}
              aria-label="More info"
              title={typeof tooltip === 'string' ? tooltip : undefined}
            />
            <div
              role="tooltip"
              className="absolute left-0 top-full mt-2 w-64 bg-gray-900 text-white text-xs rounded-md p-2 shadow-xl opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity z-20"
            >
              {tooltip}
            </div>
          </span>
        )}
      </div>
      {icon && React.cloneElement(icon, { className: `w-6 h-6 ${color}` })}
    </div>
    <div className="mt-1 flex items-end justify-between gap-3">
      <p className="text-3xl font-bold text-gray-900">{value}</p>
      {trend && (
        <div className={`ml-3 text-sm font-semibold flex items-center ${trend.includes('Up') ? 'text-green-600' : 'text-red-600'}`}>
          {trend.includes('Up') ? <TrendingUp className="w-4 h-4 mr-1" /> : <TrendingDown className="w-4 h-4 mr-1" />}
          {trend}
        </div>
      )}
    </div>
    {children && (
      <div className="mt-3">
        {children}
      </div>
    )}
  </div>
);


export default MetricCard;

